import { consoleLogger } from './console-logger';
import { sentryLogger } from './sentry-logger';
import type { Logger, LogContext } from './types';

class CompositeLogger implements Logger {
  private readonly loggers: Logger[];

  constructor() {
    this.loggers = [consoleLogger, sentryLogger];
  }

  debug(message: string, context?: LogContext): void {
    this.loggers.forEach((l) => l.debug(message, context));
  }

  info(message: string, context?: LogContext): void {
    this.loggers.forEach((l) => l.info(message, context));
  }

  warn(message: string, context?: LogContext): void {
    this.loggers.forEach((l) => l.warn(message, context));
  }

  error(message: string, error?: Error, context?: LogContext): void {
    this.loggers.forEach((l) => l.error(message, error, context));
  }
}

export const logger = new CompositeLogger();
export type { Logger, LogContext } from './types';
